import { useEffect } from "react";
import useAuthHook from "./useAuthHook";

const useWindowReset = () => {
  const { signOut } = useAuthHook();

  const reset = () => {
    if (import.meta.env.PROD) {
      signOut();
      localStorage.clear();
    }
  };

  useEffect(() => (window["reset"] = reset), []);
};

export default useWindowReset;
